<div fxLayout="column" fxHide.lt-md>
    <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
    <div *ngIf="isBrowserIE; else loanDetailsFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="loanDetailsFlexColumnTemplate"></ng-container>
    </div>
</div>

<div fxLayout="column" fxHide.gt-sm ngStyle.lt-md="padding-left: 8px; padding-right: 8px">
    <div fxFlex.lt-sm="10px" fxFlex.gt-sm="25px">&nbsp;</div>
    <ng-container *ngTemplateOutlet="loanDetailsCardViewHeaderTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="loanDetailsCardViewTemplate"></ng-container>
</div>

<ng-template #loanDetailsCardViewHeaderTemplate>
    <div fxLayout="column" fxHide.gt-sm >
    <div fxFlex.lt-sm="10px" fxFlex.gt-sm="25px">&nbsp;</div>
        <div fxFlex="90%" *ngIf="!showSpinner">
            <div class="display-text normal-paragraph-spacing">
                <mat-card>
                    <mat-card-content>
                        <div class="display-text primary-dark-color-important" *ngIf="userFullName.length > 0">
                            <span style="white-space: nowrap !important;" fxLayoutAlign="start center">
                                <b>{{ userFullName }}</b>
                            </span>
                        </div>
                        <div class="display-text primary-dark-color-important">
                            <b><span
                                    i18n="@@loan-details.list.participant-id.label">loan-details.list.participant-id.label</span>:&nbsp;{{
                                participantIdString
                                }}</b>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #loanDetailsCardViewTemplate>
    <div fxFlex="5%"></div>
    <div fxFlex="90%" *ngIf="!showSpinner">
        <div class="display-text normal-paragraph-spacing">
            <mat-card>
                <mat-card-content>
                    <div fxLayout="column">
                        <div fxLayout="column" fxLayoutGap="16px">
                            <div fxLayout="column">
                                <div *ngIf="isBrowserIE; else loanDetailsCardViewPageHeaderFlexColumnTemplate"
                                    [ngClass]="{ 'ie-display': isBrowserIE }">
                                    <ng-container
                                        *ngTemplateOutlet="loanDetailsCardViewPageHeaderFlexColumnTemplate"></ng-container>
                                </div>
                            </div>
                            <!-- Filter Control -->
                            <mat-form-field *ngIf="cardNoteList.length > 5" appearance="fill" style="width: 100%;">
                                <mat-label>Filter by Note Status</mat-label>
                                <mat-select [(ngModel)]="selectedNoteStatus" (selectionChange)="filterNotes()">
                                    <mat-option *ngFor="let status of uniqueNoteStatuses" [value]="status">
                                        {{ status }}
                                    </mat-option>
                                    <mat-option [value]="''">All</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <ng-container *ngFor="let row of filteredNotesList">
                                <mat-card *ngIf="row.noteId">
                                    <mat-card-header>
                                        <div style="width: 100%;">
                                            <!-- Left Section: Note ID and Note Status -->
                                            <div>
                                                <mat-card-title>{{ row.noteId }}
                                                    <a class="tooltip-link" (click)="openToolTip('noteId')"
                                                    style="display: inline-flex; align-items: center; vertical-align: middle;">
                                                    <mat-icon class="tooltip-icon-link"
                                                        style="font-size: 16px; vertical-align: middle; margin-left: 4px;"
                                                        matTooltip="{{ getToolTip('noteId') }}"
                                                        matTooltipPosition="after" 
                                                        matTooltipClass="tooltip-multi-line">help_outline</mat-icon>
                                                    </a>
                                                </mat-card-title>
                                                <mat-card-subtitle>{{ row.noteStatus }}
                                                    <a class="tooltip-link" (click)="openToolTip('noteStatus')"
                                                        style="display: inline-flex; align-items: center; vertical-align: middle;">
                                                        <mat-icon class="tooltip-icon-link"
                                                            style="font-size: 16px; vertical-align: middle; margin-left: 4px;"
                                                            matTooltip="{{ getToolTip('noteStatus') }}"
                                                            matTooltipPosition="after"
                                                            matTooltipClass="tooltip-multi-line">help_outline</mat-icon>
                                                    </a>
                                                </mat-card-subtitle>
                                                <div *ngIf="row.lenderName"
                                                    style="display: flex; justify-content: space-between;">
                                                    <mat-label><span class="header-superscript header-after-content-2"
                                                            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                                            i18n="@@note-detail.form.loan.lender-name.label">note-detail.form.loan.lender-name.label</span></mat-label>
                                                    <span style="text-align: right;">{{ row.lenderName }}</span>
                                                </div>
                                                <div *ngIf="row.noteDate"
                                                    style="display: flex; justify-content: space-between;">
                                                    <mat-label><span class="header-superscript header-after-content-2"
                                                            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                                            i18n="@@loan-details.list.table.column-header.note-date">loan-details.list.table.column-header.note-date</span></mat-label>
                                                    <span style="text-align: right;">{{ row.noteDate }}</span>
                                                </div>
                                                <div  style="display: flex; justify-content: space-between;">
                                                    <mat-label>
                                                        <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                                            i18n="@@loan-details.list.table.column-header.cpb">loan-details.list.table.column-header.cpb</span>
                                                        <a class="tooltip-link" (click)="openToolTip('cpb')">
                                                            <mat-icon class="tooltip-icon-link"
                                                                matTooltip="{{ getToolTip('cpb') }}"
                                                                matTooltipPosition="after"
                                                                matTooltipClass="tooltip-multi-line">help_outline</mat-icon>
                                                        </a>
                                                    </mat-label>
                                                    <span style="text-align: right;">{{ row.cpb | currency }}</span>
                                                </div>
                                                 <div 
                                                    style="display: flex; justify-content: space-between;">
                                                    <mat-label>
                                                        <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                                            i18n="@@loan-details.list.table.column-header.total-amount-due">loan-details.list.table.column-header.total-amount-due</span>
                                                    </mat-label>
                                                    <span style="text-align: right;">{{ row.totalAmountDue | currency }}</span>
                                                </div>
                                            </div>

                                        </div>
                                    </mat-card-header>
                                    <mat-card-actions
                                        style="display: flex; justify-content: right; align-items: right;">
                                        <button mat-flat-button color="primary" (click)="selectCardNote(row.noteId)"
                                            i18n-matTooltip="@@esign-details.table.column-header.options"
                                            matTooltip="esign-details.table.column-header.options"
                                            i18n="@@esign-details.table.column-header.options">
                                            esign-details.table.column-header.options
                                        </button>
                                    </mat-card-actions>
                                    <!-- Dynamically Render Note Details -->
                                    <mat-card-content *ngIf="selectedNoteId === row.noteId">

                                        <div fxLayout="column" class="primary-lightest-bg note-details"
                                            *ngIf="selectedNoteId !== null && selectedNoteId > 0">
                                            <ng-container
                                                *ngTemplateOutlet="loanDetailsNoteDetailFlexColumnTemplate"></ng-container>
                                        </div>

                                    </mat-card-content>

                                </mat-card>
                            </ng-container>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #loanDetailsCardViewPageHeaderFlexColumnTemplate>
    <div fxFlex="5%"></div>
    <div fxLayout="column" fxFlex="90%">
        <div class="display-text primary-dark-color-important" *ngIf="userFullName.length > 0">
            <span style="white-space: nowrap !important;" fxLayoutAlign="start center">
                <b><span i18n="@@page-header.loan-details">page-header.loan-details</span></b>
            </span>
        </div>
        <div fxFlex="100%" class="border-bottom-blue" style="margin-top: 16px"></div>
    </div>
</ng-template>

<ng-template #loanDetailsFlexColumnTemplate>
    <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
    <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
        <div *ngIf="isBrowserIE && media.isActive('lt-md'); else loanDetailsMainFlexColumnTemplate">
            <ng-container *ngTemplateOutlet="loanDetailsMainFlexColumnTemplate"></ng-container>
        </div>
    </div>
    <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
</ng-template>

<ng-template #loanDetailsMainFlexColumnTemplate>
    <div fxFlex="5%" fxHide.lt-md></div>
    <div fxFlex="90%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px" *ngIf="showSpinner">
        <div class="display-text normal-paragraph-spacing" style="text-align: center">
            <mat-spinner color="accent" diameter="64"></mat-spinner>
        </div>
    </div>
    <div fxFlex="90%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px" *ngIf="!showSpinner">
        <div class="display-text normal-paragraph-spacing">
            <mat-card>
                <mat-card-content>
                    <div fxLayout="column" *ngIf="!notesFound">
                        <div *ngIf="isBrowserIE; else loanDetailsNoRecordsFlexColumnTemplate"
                            [ngClass]="{ 'ie-display': isBrowserIE }">
                            <ng-container *ngTemplateOutlet="loanDetailsNoRecordsFlexColumnTemplate"></ng-container>
                        </div>
                    </div>
                    <div fxLayout="column" *ngIf="notesFound">
                        <div *ngIf="isBrowserIE; else loanDetailsListFlexColumnTemplate"
                            [ngClass]="{ 'ie-display': isBrowserIE }">
                            <ng-container *ngTemplateOutlet="loanDetailsListFlexColumnTemplate"></ng-container>
                        </div>
                    </div>
                    <ng-container *ngTemplateOutlet="loanDetailsNoteDetailsTemplate"></ng-container>
                    <div fxLayout="column">
                        <div *ngIf="isBrowserIE; else loanDetailsScrollToTopFlexColumnTemplate"
                            [ngClass]="{ 'ie-display': isBrowserIE }">
                            <ng-container *ngTemplateOutlet="loanDetailsScrollToTopFlexColumnTemplate"></ng-container>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #loanDetailsNoteDetailsTemplate>

    <div fxLayout="column" class="primary-lightest-bg" *ngIf="selectedNoteId !== null && selectedNoteId > 0"
        id="noteDetails">
        <div *ngIf="isBrowserIE; else loanDetailsNoteDetailFlexColumnTemplate"
            [ngClass]="{ 'ie-display': isBrowserIE }">
            <ng-container *ngTemplateOutlet="loanDetailsNoteDetailFlexColumnTemplate"></ng-container>
        </div>
    </div>

</ng-template>

<ng-template #loanDetailsNoRecordsFlexColumnTemplate>
    <div fxLayout="column">
        <div class="display-text primary-dark-color-important" *ngIf="userFullName.length > 0">
            <span style="white-space: nowrap !important;" fxLayoutAlign="start center">
                <b>{{ userFullName }}</b>
            </span>
        </div>
        <div class="display-text primary-dark-color-important">
            <b><span
                    i18n="@@loan-details.list.participant-id.label">loan-details.list.participant-id.label</span>:&nbsp;{{
                participantIdString
                }}</b>
        </div>
        <div class="display-text">
            <i><span i18n="@@loan-details.list.no-records-text">loan-details.list.no-records-text</span></i>
        </div>
    </div>
</ng-template>

<ng-template #loanDetailsListFlexColumnTemplate>
    <div fxLayout="column">
        <div class="display-text primary-dark-color-important" *ngIf="userFullName.length > 0">
            <span style="white-space: nowrap !important;" fxLayoutAlign="start center">
                <b>{{ userFullName }}</b>
            </span>
        </div>
        <div class="display-text primary-dark-color-important">
            <b><span
                    i18n="@@loan-details.list.participant-id.label">loan-details.list.participant-id.label</span>:&nbsp;{{
                participantIdString
                }}</b>
        </div>
        <div class="display-text">
            <i><span i18n="@@loan-details.list.top-helper-text">loan-details.list.top-helper-text</span></i>
        </div>
        <div *ngIf="isBrowserIE; else loanDetailsListTableFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
            <ng-container *ngTemplateOutlet="loanDetailsListTableFlexColumnTemplate"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #loanDetailsScrollToTopFlexColumnTemplate>
    <div fxLayout="column" *ngIf="notesFound">
        <div fxLayoutAlign="center center" style="margin-top: 24px;">
            <button mat-stroked-button color="primary" (click)="scrollToTop()" i18n="@@loan-details.list.go-to-top">
                loan-details.list.go-to-top
            </button>
        </div>
    </div>
</ng-template>

<ng-template #loanDetailsListTableFlexColumnTemplate>
    <div fxFlex="100%" class="border-bottom-blue" style="margin-top: 16px"></div>
    <div fxFlex="100%" [ngStyle]="{ display: tableDisplayStyle }" style="margin-top: 12px">
        <mat-table #table [dataSource]="tableDataSource" ngClass.lt-md="small-table-text">
            <!-- noteId Column -->
            <ng-container matColumnDef="noteId">
                <mat-header-cell *matHeaderCellDef fxFlex="16%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@loan-details.list.table.column-header.note-id">loan-details.list.table.column-header.note-id</span>
                    <a class="tooltip-link" (click)="openToolTip('noteId')">
                        <mat-icon class="tooltip-icon-link" matTooltip="{{ getToolTip('noteId') }}"
                            matTooltipPosition="after" matTooltipClass="tooltip-multi-line">help_outline</mat-icon>
                    </a>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="16%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">
                    <button mat-button color="primary" (click)="selectNote(row.noteId)">
                        <b>{{ row.noteId }}</b>
                    </button>
                </mat-cell>
            </ng-container>
            <!-- noteStatus Column -->
            <ng-container matColumnDef="noteStatus">
                <mat-header-cell *matHeaderCellDef fxFlex="14%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@loan-details.list.table.column-header.note-status">loan-details.list.table.column-header.note-status</span>
                    <a class="tooltip-link" (click)="openToolTip('noteStatus')">
                        <mat-icon class="tooltip-icon-link" matTooltip="{{ getToolTip('noteStatus') }}"
                            matTooltipPosition="after" matTooltipClass="tooltip-multi-line">help_outline</mat-icon>
                    </a>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="14%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">
                    {{ row.noteStatus }}
                </mat-cell>
            </ng-container>
            <!-- noteDate Column -->
            <ng-container matColumnDef="noteDate">
                <mat-header-cell *matHeaderCellDef fxFlex="14%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@loan-details.list.table.column-header.note-date">loan-details.list.table.column-header.note-date</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="14%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">
                    {{ row.noteDate }}
                </mat-cell>
            </ng-container>
            <!-- cpb Column -->
            <ng-container matColumnDef="cpb">
                <mat-header-cell *matHeaderCellDef fxFlex="14%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@loan-details.list.table.column-header.cpb">loan-details.list.table.column-header.cpb</span>
                    <a class="tooltip-link" (click)="openToolTip('cpb')">
                        <mat-icon class="tooltip-icon-link" matTooltip="{{ getToolTip('cpb') }}"
                            matTooltipPosition="after" matTooltipClass="tooltip-multi-line">help_outline</mat-icon>
                    </a>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="14%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">
                    {{ row.cpb | currency }}
                </mat-cell>
            </ng-container>
            <!-- nextPaymentDueDate Column -->
            <ng-container matColumnDef="nextPaymentDueDate">
                <mat-header-cell *matHeaderCellDef fxFlex="14%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@loan-details.list.table.column-header.next-payment-due-date">loan-details.list.table.column-header.next-payment-due-date</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="14%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">
                    {{ row.nextPaymentDueDate }}
                </mat-cell>
            </ng-container>
            <!-- pastDueAmount Column -->
            <ng-container matColumnDef="pastDueAmount">
                <mat-header-cell *matHeaderCellDef fxFlex="14%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@loan-details.list.table.column-header.past-due-amount">loan-details.list.table.column-header.past-due-amount</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="14%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">
                    {{ row.pastDueAmount | currency }}
                </mat-cell>
            </ng-container>
            <!-- totalAmountDue Column -->
            <ng-container matColumnDef="totalAmountDue">
                <mat-header-cell *matHeaderCellDef fxFlex="14%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@loan-details.list.table.column-header.total-amount-due">loan-details.list.table.column-header.total-amount-due</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="14%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">
                    {{ row.totalAmountDue | currency }}
                </mat-cell>
            </ng-container>

            <!-- Group Header -->
            <ng-container matColumnDef="groupHeader">
                <td class="mat-group-header-cell accent-color-important"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }" colspan="7" mat-cell *matCellDef="let groupHeader"
                    fxFlex="100%" fxLayoutAlign="start end">
                    {{ groupHeader.headerTitle }}
                </td>
            </ng-container>
            <tr mat-row class="primary-lightest-bg-top-to-bottom-gradient"
                *matRowDef="let row; columns: ['groupHeader']; when: isGroupHeader"></tr>

            <!-- Group Footer -->
            <ng-container matColumnDef="groupFooterTotals">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }"
                    style="padding-right: 20px;" mat-cell *matCellDef="let groupFooter" fxFlex="44%"
                    fxLayoutAlign="end center">
                    <strong><span
                            i18n="@@loan-details.list.table.group-footer.totals">loan-details.list.table.group-footer.totals</span>:</strong>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupFooterEmptyColumn">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }" mat-cell
                    *matCellDef="let groupFooter" fxFlex="14%" fxLayoutAlign="center center"></td>
            </ng-container>
            <ng-container matColumnDef="groupFooterCPBTotal">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }" mat-cell
                    *matCellDef="let groupFooter" fxFlex="14%" fxLayoutAlign="start center">
                    <strong>{{ groupFooter.cpbTotal | currency }}</strong>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupFooterPastDueAmountTotal">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }" mat-cell
                    *matCellDef="let groupFooter" fxFlex="14%" fxLayoutAlign="start center">
                    <strong>{{ groupFooter.pastDueAmountTotal | currency }}</strong>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupFooterTotalAmountDueTotal">
                <td class="mat-cell-group-footer" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }" mat-cell
                    *matCellDef="let groupFooter" fxFlex="14%" fxLayoutAlign="start center">
                    <strong>{{ groupFooter.totalAmountDueTotal | currency }}</strong>
                </td>
            </ng-container>
            <tr mat-row *matRowDef="
          let row;
          columns: [
            'groupFooterTotals',
            'groupFooterCPBTotal',
            'groupFooterEmptyColumn',
            'groupFooterPastDueAmountTotal',
            'groupFooterTotalAmountDueTotal'
          ];
          when: isGroupFooter
        "></tr>

            <mat-header-row class="primary-light-bg-top-to-bottom-gradient" *matHeaderRowDef="tableDisplayedColumns"
                ngClass.lt-md="small-header-row"></mat-header-row>
            <mat-row *matRowDef="let row; columns: tableDisplayedColumns" ngClass.lt-md="small-row"
                [ngClass]="{ 'primary-lightest-bg': row.noteId === selectedNoteId }"></mat-row>
        </mat-table>
    </div>
    <div fxFlex="100%" fxLayoutAlign="end center" class="small-display-text primary-light-color" *ngIf="notesCount > 0">
        <app-table-record-count [recordCount]="notesCount"
            i18n-singularLabel="@@loan-details.list.table.record-count.singular-label"
            singularLabel="loan-details.list.table.record-count.singular-label"
            i18n-multipleLabel="@@loan-details.list.table.record-count.multiple-label"
            multipleLabel="loan-details.list.table.record-count.multiple-label"></app-table-record-count>
    </div>
    <div fxFlex="100%" style="margin-top: 16px"></div>
</ng-template>

<ng-template #loanDetailsNoteDetailFlexColumnTemplate>
    <div fxFlex="100%" ngStyle.lt-sm="padding: .5rem 1rem;" ngStyle.gt-xs="padding: 1rem 1rem;"></div>
    <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
        <div *ngIf="isBrowserIE && media.isActive('lt-md'); else loanDetailsNoteDetailTwoColumnsFlexColumnTemplate">
            <ng-container *ngTemplateOutlet="loanDetailsNoteDetailTwoColumnsFlexColumnTemplate"></ng-container>
        </div>
    </div>
    <div fxFlex="100%" style="margin-top: 24px;"></div>
</ng-template>

<ng-template #loanDetailsNoteDetailTwoColumnsFlexColumnTemplate>
    <div fxFlex="5%" fxHide.lt-md></div>
    <div fxFlex.lt-md="100%" fxFlex.gt-sm="45%">
        <app-note-detail [noteDetailType]="noteDetailTypes.Loan" [noteId]="this.selectedNoteId"></app-note-detail>
    </div>
    <div fxFlex.lt-md="100%" fxFlex.gt-sm="45%">
        <div fxLayout="column">
            <div *ngIf="isBrowserIE; else loanDetailsNoteDetailRightColumnFlexColumnTemplate"
                [ngClass]="{ 'ie-display': isBrowserIE }">
                <ng-container *ngTemplateOutlet="loanDetailsNoteDetailRightColumnFlexColumnTemplate"></ng-container>
            </div>
        </div>
    </div>
    <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #loanDetailsNoteDetailRightColumnFlexColumnTemplate>
    <app-note-repay-schedule-list [noteId]="this.selectedNoteId"></app-note-repay-schedule-list>
    <app-note-disbursement-schedule-list [noteId]="this.selectedNoteId"
        style="margin-top: 36px;"></app-note-disbursement-schedule-list>
</ng-template>